import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_FILES = restRequest("VRCORE.FILE_MANAGER.GET_FILES");
export const GET_FOLDERS = restRequest("VRCORE.FILE_MANAGER.GET_FOLDERS");
export const SET_DATE_FROM = "VRCORE.FILE_MANAGER.SET_DATE_FROM";
export const SET_DATE_TO = "VRCORE.FILE_MANAGER.SET_DATE_TO";
export const SET_FILTER_STATUS = "VRCORE.FILE_MANAGER.SET_FILTER_STATUS";
export const SET_SEARCH_JOB_ID = "VRCORE.FILE_MANAGER.SET_SEARCH_JOB_ID";
export const SET_ROW = "VRCORE.FILE_MANAGER.SET_ROW";
export const SET_PAGE = "VRCORE.FILE_MANAGER.SET_PAGE";
export const SET_FOLDER = "VRCORE.FILE_MANAGER.SET_FOLDER";
export const SET_SELECTED = "VRCORE.FILE_MANAGER.SET_SELECTED";
export const UPLOAD_FILE = restRequest("VRCORE.FILE_MANAGER.UPLOAD_FILE");
export const CREATE_FOLDER = restRequest("VRCORE.FILE_MANAGER.CREATE_FOLDER");
export const REMOVE_FILE = restRequest("VRCORE.FILE_MANAGER.REMOVE_FILE");
export const MOVE_FILES = restRequest("VRCORE.FILE_MANAGER.MOVE_FILES");
export const GET_POLICIES = restRequest("VRCORE.FILE_MANAGER.GET_POLICIES")
